import { request } from '@umijs/max';

/**
 * 获取资产列表
 */
export async function getAssetList(params: OA.AssetListParams) {
  return request<OA.ApiResponse<OA.PaginatedResponse<OA.Asset>>>('/api/v1/assets/', {
    method: 'GET',
    params,
  });
}

/**
 * 获取资产类别列表
 */
export async function getAssetCategories() {
  return request<OA.ApiResponse<string[]>>('/api/v1/assets/categories', {
    method: 'GET',
  });
}

/**
 * 获取资产详情
 */
export async function getAssetDetail(id: number) {
  return request<OA.ApiResponse<OA.Asset>>(`/api/v1/assets/${id}`, {
    method: 'GET',
  });
}

/**
 * 创建资产
 */
export async function createAsset(data: OA.AssetCreate) {
  return request<OA.ApiResponse<OA.Asset>>('/api/v1/assets/', {
    method: 'POST',
    data,
  });
}

/**
 * 更新资产
 */
export async function updateAsset(id: number, data: OA.AssetUpdate) {
  return request<OA.ApiResponse<OA.Asset>>(`/api/v1/assets/${id}`, {
    method: 'PUT',
    data,
  });
}

/**
 * 删除资产
 */
export async function deleteAsset(id: number) {
  return request<OA.ApiResponse<any>>(`/api/v1/assets/${id}`, {
    method: 'DELETE',
  });
}

/**
 * 批量导入资产
 */
export async function importAssets(file: File) {
  const formData = new FormData();
  formData.append('file', file);

  return request<OA.ApiResponse<OA.ImportResult>>('/api/v1/assets/import', {
    method: 'POST',
    data: formData,
    requestType: 'form',
  });
}

/**
 * 批量删除资产
 */
export async function batchDeleteAssets(assetIds: number[]) {
  return request<OA.ApiResponse<any>>('/api/v1/assets/batch-delete', {
    method: 'POST',
    data: assetIds,
  });
}
